module.exports = __webpack_public_path__ + "img/img_wa.9b819965.png";